import React, { useState } from "react";
import {
  Flex,
  Box,
  Text,
  Input,
  Button,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  IconButton,
  Icon,
  // useToast,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import { Global, css } from "@emotion/react";
import {
  // useParams, Link,
  useNavigate,
} from "react-router-dom";
import { FiMail, FiLock, FiEye, FiEyeOff } from "react-icons/fi";
import { loginUser } from "./LoginServices";
import photo from "../../../assets/images/photo.png";
import CommonToastMessage from "../../../components/alert/CommonToastMessage";
import * as Constants from "../../../constants/Constants";
const MotionBox = motion(Box);

const LoginScreen = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  // const toast = useToast();
  const { addToast } = CommonToastMessage();
  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const res = await loginUser({ email, password });
      setIsLoading(false);
      console.log(res);
      if (res.data.success) {
        sessionStorage.setItem("isAdmin", "true");
        navigate("/contact");
        addToast({
          alertStatus: Constants.TOAST_TYPE_SUCESS,
          alertTitle: "Login Successful",
          alertDescription: "You're in! Welcome to Glass & Door Premium.",
          // title: "Login Successful",
          // description: "You're in! Welcome to Glass & Door Premium.",
          // status: "success",
          // duration: 3000,
          // isClosable: true,
          // position: "bottom",
        });
      } else {
        throw new Error(res.data.message || "Login failed");
      }
    } catch (error) {
      setIsLoading(false);
      addToast({
        alertStatus: Constants.TOAST_TYPE_WARNING,
        alertTitle: "Login Failed",
        alertDescription: "Permission denied.",
        // title: "Login Failed",
        // description: "Permission denied.",
        // // description: error.response?.data?.message || error.message,
        // status: "error",
        // duration: 3000,
        // isClosable: true,
        // position: "bottom",
      });
    }
    // Simulate authentication
    // setTimeout(() => {
    //   setIsLoading(false);
    //   if (res.data.success) {
    //     toast({
    //       title: "Login Successful",
    //       description: "Welcome to Glass & Door Premium",
    //       status: "success",
    //       duration: 3000,
    //       isClosable: true,
    //       position: "top",
    //     });
    //   } else {
    //     toast({
    //       title: "Login Failed",
    //       description: "Please enter both email and password",
    //       status: "error",
    //       duration: 3000,
    //       isClosable: true,
    //       position: "top",
    //     });
    //   }
    // }, 1500);
  };

  return (
    <Flex
      minH="100vh"
      align="center"
      justify="center"
      bgImage={`url(${photo})`}
      // bgImage="url('https://images.unsplash.com/photo-1605152276897-4f618f831968?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80')"
      // bgImage="url('https://images.unsplash.com/photo-1517502884422-41eaead166d4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80')"
      // bgImage="url('https://images.unsplash.com/photo-1605152276897-4f618f831968?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80')"
      // bgImage="url('https://images.unsplash.com/photo-1497366811353-6870744d04b2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80')"
      //building glass
      // bgImage="url('https://images.unsplash.com/photo-1487958449943-2429e8be8625?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80')"
      //high building glass
      // bgImage="url('https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80')"
      //sea
      // bgImage="url('https://images.unsplash.com/photo-1499793983690-e29da59ef1c2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80')"
      bgSize="cover"
      bgPosition="center"
      position="relative"
      _after={{
        content: '""',
        position: "absolute",
        inset: 0,
        bg: "linear-gradient(135deg, rgba(0,0,0,0.6) 0%, rgba(26,26,26,0.8) 100%)",
      }}
    >
      <MotionBox
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        zIndex="1"
        p={8}
        rounded="xl"
        backdropFilter="blur(10px) saturate(180%)"
        // bg="rgba(15, 15, 15, 0.7)"
        border="1px solid rgba(212, 175, 55, 0.4)"
        boxShadow="0 10px 40px rgba(0, 0, 0, 0.4)"
        w={{ base: "90%", md: "500px" }}
        position="relative"
        overflow="hidden"
        _before={{
          content: '""',
          position: "absolute",
          top: "-50%",
          left: "-50%",
          width: "200%",
          height: "200%",
          background:
            "linear-gradient(45deg, transparent 45%, rgba(212, 175, 55, 0.1) 50%, transparent 55%)",
          animation: "shine 6s infinite linear",
          zIndex: "-1",
        }}
      >
        {/* Glass pane reflection effect */}
        <Box
          position="absolute"
          top="0"
          right="0"
          w="0%"
          h="100%"
          bg="linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.03) 50%, rgba(255,255,255,0) 100%)"
          transform="skewX(-20deg)"
          pointerEvents="none"
        />

        <Flex direction="column" align="center" mb={8}>
          <Box
            p={3}
            mb={4}
            border="2px solid"
            borderColor="gold.400"
            borderRadius="full"
            boxShadow="0 0 20px rgba(212, 175, 55, 0.4)"
          >
            <svg
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#D4AF37"
              strokeWidth="2"
            >
              {/* Custom glass door icon */}
              <rect
                x="3"
                y="3"
                width="18"
                height="18"
                rx="1"
                strokeLinecap="round"
              />
              <line x1="12" y1="3" x2="12" y2="21" strokeLinecap="round" />
              <circle cx="16" cy="12" r="1" fill="#D4AF37" />
            </svg>
          </Box>
          <Text
            fontSize="2xl"
            fontWeight="bold"
            color="gold.300"
            letterSpacing="1px"
            textTransform="uppercase"
            textShadow="0 2px 4px rgba(0,0,0,0.3)"
          >
            Enso Universal
          </Text>
          <Text color="#000000" mt={2} fontSize="sm">
            Exclusive Access for Partners
          </Text>
        </Flex>

        <InputGroup mb={5}>
          <InputLeftElement pointerEvents="none" color="gold.300">
            <Icon as={FiMail} color="#000000" boxSize={"1.3rem"} />
          </InputLeftElement>
          <Input
            type="email"
            placeholder="Access Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            pl={10}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSubmit(e);
              }
            }}
            bg="rgba(255,255,255,0.05)"
            border="1px solid rgba(255,255,255,0.1)"
            _hover={{ borderColor: "rgba(212, 175, 55, 0.3)" }}
            _focus={{
              borderColor: "gold.400",
              boxShadow: "0 0 0 1px gold.400",
              bg: "rgba(212, 175, 55, 0.05)",
            }}
            color="white"
            transition="all 0.3s"
          />
        </InputGroup>

        <InputGroup mb={6}>
          <InputLeftElement pointerEvents="none" color="gold.300">
            <Icon as={FiLock} color="#000000" boxSize={"1.3rem"} />
          </InputLeftElement>
          <Input
            type={showPassword ? "text" : "password"}
            placeholder="Secure Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            pl={10}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSubmit(e);
              }
            }}
            bg="rgba(255,255,255,0.05)"
            border="1px solid rgba(255,255,255,0.1)"
            _hover={{ borderColor: "rgba(212, 175, 55, 0.3)" }}
            _focus={{
              borderColor: "gold.400",
              boxShadow: "0 0 0 1px gold.400",
              bg: "rgba(212, 175, 55, 0.05)",
            }}
            color="white"
            transition="all 0.3s"
          />
          <InputRightElement>
            <IconButton
              aria-label={showPassword ? "Hide password" : "Show password"}
              icon={showPassword ? <FiEyeOff /> : <FiEye />}
              variant="ghost"
              color="gold.300"
              _hover={{ bg: "rgba(212, 175, 55, 0.1)" }}
              onClick={() => setShowPassword(!showPassword)}
            />
          </InputRightElement>
        </InputGroup>

        <Button
          type="submit"
          w="full"
          onClick={handleSubmit}
          // bgGradient="linear(to-r, gold.500, gold.600)"
          color="white"
          fontWeight="semibold"
          fontSize="md"
          py={6}
          borderRadius="md"
          isLoading={isLoading}
          bg="linear(to-r, gold.400, gold.500)"
          bgGradient="linear(to-r, gold.400, gold.500)"
          transform="translateY(-2px)"
          boxShadow="0 4px 15px rgba(212, 175, 55, 0.4)"
          _hover={{
            bgGradient: "linear(to-r, gold.400, gold.500)",
            transform: "translateY(-2px)",
            boxShadow: "0 4px 15px rgba(212, 175, 55, 0.4)",
          }}
          _active={{
            bgGradient: "linear(to-r, gold.600, gold.700)",
          }}
          transition="all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
          mb={5}
        >
          ACCESS SYSTEM
        </Button>

        {/* <Flex justify="space-between" fontSize="sm" color="#000000">
            <Link 
              href="#"
              position="relative"
              _hover={{ color: "gold.300", textDecoration: "none" }}
              _after={{
                content: '""',
                position: "absolute",
                bottom: "-1px",
                left: 0,
                width: "0%",
                height: "1px",
                bg: "gold.300",
                transition: "width 0.3s ease",
              }}
              _hover={{
                _after: { width: "100%" },
              }}
            >
              Request Access
            </Link>
            <Link 
              href="#"
              position="relative"
              _hover={{ color: "gold.300", textDecoration: "none" }}
              _after={{
                content: '""',
                position: "absolute",
                bottom: "-1px",
                left: 0,
                width: "0%",
                height: "1px",
                bg: "gold.300",
                transition: "width 0.3s ease",
              }}
              _hover={{
                _after: { width: "100%" },
              }}
            >
              Technical Support
            </Link>
          </Flex> */}
      </MotionBox>

      <Global
        styles={css`
          @keyframes shine {
            from {
              transform: translateX(-50%) translateY(-50%) rotate(45deg);
            }
            to {
              transform: translateX(50%) translateY(50%) rotate(45deg);
            }
          }
        `}
      />
    </Flex>
  );
};

export default LoginScreen;
